import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import Product from "emun.shopping/product.model";
import partsEntryGridTemplate from "emun.order/parts/parts-entry-grid.htm";
import labels from "emun.order/_labels";
import ProductListPicker from "emun.products/lists/product-list-picker";
import resolve from "ioc/resolve";
import modals from "webmodals/modals";
import actionList from "webmodals/action-list";
import ServiceBus from "servicestack/service-bus";

const $localStorage = resolve("$localStorage");
const $rootScope = resolve("$rootScope");

export default class OrderManualSplitController {
	constructor(notify) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.labels = labels;
		$ctrl.notify = notify;
		$ctrl.bus = new ServiceBus();
	}

	$onInit() {
		const $ctrl = this;
		$ctrl.$cart.items.map((l) => (l.selected = false));
	}

	selectAll() {
		const $ctrl = this;
		$ctrl.$cart.items.map(item => { item.selected = true });
		$ctrl.setProductIds();
	}
	copyOrder(reprice = false) {
		const $ctrl = this;
		return modals.dialog({
			body: `Would you like to retain pricing from current order?`,
			title: `Retain Pricing?`,
			size: 'md',
			buttons: {
				'Reprice New Order': {
					dismiss: true,
				},
				'Retain Pricing': {
				  className: 'btn-u-default'
				},
			}
		}).result.then(
		  () => $ctrl.newOrder(false, false), 
		() => $ctrl.newOrder(false, true));
	}
	newOrder(overrideWarnings = false, reprice = false) {
		const $ctrl = this;
		$ctrl.$dismiss();
		var cartId = $ctrl.$cart.id;
		let url = `DuplicateOrder/${cartId}`;
		let busy = modals.busy(
			"Copying order...",
			`Thank you for your patience as order ${cartId} is duplicated.`
		);
		$ctrl.bus
			.send(url, {
				OrderNumber: $ctrl.$cart.id,
				LinePositions: $ctrl.$cart.items
					.filter((l) => l.selected)
					.map((l) => l.position),
				RemoveLines: false,
				Reprice: reprice,
				OverrideWarnings: overrideWarnings
			})
			.then((response) => {
				response.data.messages.forEach((msg) =>
					($ctrl.notify.warning || $ctrl.notify.error || $ctrl.notify.info)(msg, {
						ttl: 2000,
						disableCountDown: true,
					})
				);
				return $ctrl.$cart.load(response.data.id).then(() => {
					$ctrl.$cart.view({ mode: "Order", openedit: true });
				});

			})
			.catch((response) => {
				if (response.data.responseStatus.errorCode === "Warning") {
					var body = "";
					response.data.responseStatus.errors.map(e => body = body + e.message + "\r\n");
					body = body + "\r\nContinue with copy?";
					return modals.confirm(body, "Some items cannot be copied", "lg").result.then(function () {
						$ctrl.newOrder(true, reprice);
					});
				} else {
					modals.alert(response.data.responseStatus.message);
				}

			})
			.finally(busy.close);
	}

	save() {
		const $ctrl = this;
	}
	setProductIds() {
		const $ctrl = this;
		$ctrl.productIds = $ctrl.$cart.items
			.filter((l) => l.selected)
			.map((l) => l.productId)
			.join(",");
	}
}
